
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Location } from './location';


@Injectable({ providedIn: 'root' })
export class LocationService {
  constructor(private http: HttpClient) {}

  locationurl = environment.appURL + "/locations";
  locationLightUrl = this.locationurl + "_light";

  // UPDATE LOCATION 
  updatelocation(location: Location): Observable<any> {

    let upd = this.locationStr(location);


    console.log(upd);
    return this.http.put<Location>(this.locationurl + "/" + location.id, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<Comment>('updateStatus'))
      );
  }

  // GET ALL LOCATIONS (LIGHT VERSION)
  getLocations() {
    return this.http.get<Location[]>(this.locationLightUrl, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(
      tap(_ => { }),
      catchError(this.handleError('getLocations', []))
    );
  }

  // GET LOACTIONS BY CLIENT ID
  getLocationsByClId(client: number) {
    return this.http.get<Location[]>(this.locationLightUrl + "?client=" + client, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(
      tap(_ => { }),
      catchError(this.handleError('getLocations', []))
    );
  }

  // CREATE LOCATION 
  createLocation(newlocation: Location) {
    var upd = JSON.stringify(newlocation);

    return this.http.post<Location>(`${environment.appURL}/locations/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  // HANDLE ERRORS
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  // GET LOACATION JSON STRING 
  locationStr(location: Location): string {
    return "{\"addr1\":\"" + location.addr1 + "\",\"addr2\":\"" + location.addr2 + "\" ,\"City\":\"" + location.City + "\",\"Country\":\"" + location.Country + "\"   }";
  }


}
